<template>
	<div>
		<div class="fs4 fw7 lh125 mt6 mb2">Type of Vehicle</div>
		<case-form :schema="schemaVehicle" />

		<div class="fs4 fw7 lh125 mt6 mb2">Purpose of racing</div>
		<case-form :schema="schemaPurpose" />

		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "What type of racing or competition do you engage in?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0typeOfRacingOrCompetition`,
					props: {
						suggest: {
							typeIncludes: `typeOfRacingOrCompetition`
						},
						createOptions: {
							type: `typeOfRacingOrCompetition`,
							dataType: "string"
						}
					}
				},
				{
					label: "If drag racing, what is the elapsed time of the races?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0dragRacingElapsedTime`,
					props: {
						suggest: {
							typeIncludes: `dragRacingElapsedTime`
						},
						createOptions: {
							type: `dragRacingElapsedTime`,
							dataType: "string"
						}
					}
				},
				{
					label: "Do you compete under a sanctioning body?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isRaceUnderSanctioningBody`,
					props: {
						suggest: {
							typeIncludes: `isRaceUnderSanctioningBody`
						},
						createOptions: {
							type: `isRaceUnderSanctioningBody`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0raceUnderSanctioningBodyDetails`,
					props: {
						suggest: {
							typeIncludes: `raceUnderSanctioningBodyDetails`
						},
						createOptions: {
							type: `raceUnderSanctioningBodyDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "Number of races in the last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfRacesLast12Months`,
					props: {
						suggest: {
							typeIncludes: `numOfRacesLast12Months`
						},
						createOptions: {
							type: `numOfRacesLast12Months`,
							dataType: "number"
						}
					}
				},
				{
					label: "Number of races in the last 12 –24 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfRacesLast12to24Months`,
					props: {
						suggest: {
							typeIncludes: `numOfRacesLast12to24Months`
						},
						createOptions: {
							type: `numOfRacesLast12to24Months`,
							dataType: "number"
						}
					}
				},
				{
					label: "Races expected in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfRacesNext12Months`,
					props: {
						suggest: {
							typeIncludes: `numOfRacesNext12Months`
						},
						createOptions: {
							type: `numOfRacesNext12Months`,
							dataType: "number"
						}
					}
				},
				{
					label: "Maximum speed attained",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0maxRaceSpeedAttained`,
					props: {
						suggest: {
							typeIncludes: `maxRaceSpeedAttained`
						},
						createOptions: {
							type: `maxRaceSpeedAttained`,
							dataType: "string"
						}
					}
				},
				{
					label: "Average speed",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageRaceSpeedAttained`,
					props: {
						suggest: {
							typeIncludes: `averageRaceSpeedAttained`
						},
						createOptions: {
							type: `averageRaceSpeedAttained`,
							dataType: "string"
						}
					}
				},
				{
					label: "Provide details of the type of track and surface used.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0raceTrackDetails`,
					props: {
						suggest: {
							typeIncludes: `raceTrackDetails`
						},
						createOptions: {
							type: `raceTrackDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "Have you ever done or do you intend to do any stunt driving?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTriedStuntDriving`,
					props: {
						suggest: {
							typeIncludes: `hasTriedStuntDriving`
						},
						createOptions: {
							type: `hasTriedStuntDriving`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0stuntDrivingDetails`,
					props: {
						suggest: {
							typeIncludes: `stuntDrivingDetails`
						},
						createOptions: {
							type: `stuntDrivingDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "Have you had any accidents related to driving?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDrivingAccident`,
					props: {
						suggest: {
							typeIncludes: `hasDrivingAccident`
						},
						createOptions: {
							type: `hasDrivingAccident`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drivingAccidentDetails`,
					props: {
						suggest: {
							typeIncludes: `drivingAccidentDetails`
						},
						createOptions: {
							type: `drivingAccidentDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaVehicle() {
			return [
				{
					label: "Automobile",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isRaceVehicleAutomobile`,
					props: {
						suggest: {
							typeIncludes: `isRaceVehicleAutomobile`
						},
						createOptions: {
							type: `isRaceVehicleAutomobile`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Motorcycle",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isRaceVehicleMotorcycle`,
					props: {
						suggest: {
							typeIncludes: `isRaceVehicleMotorcycle`
						},
						createOptions: {
							type: `isRaceVehicleMotorcycle`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Power Boat",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isRaceVehiclePowerBoat`,
					props: {
						suggest: {
							typeIncludes: `isRaceVehiclePowerBoat`
						},
						createOptions: {
							type: `isRaceVehiclePowerBoat`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0raceVehicleDetails`,
					props: {
						suggest: {
							typeIncludes: `raceVehicleDetails`
						},
						createOptions: {
							type: `raceVehicleDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPurpose() {
			return [
				{
					label: "Professional",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0racePurposeProfessional`,
					props: {
						suggest: {
							typeIncludes: `racePurposeProfessional`
						},
						createOptions: {
							type: `racePurposeProfessional`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Amateur",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0racePurposeAmateur`,
					props: {
						suggest: {
							typeIncludes: `racePurposeAmateur`
						},
						createOptions: {
							type: `racePurposeAmateur`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0racePurposeDetails`,
					props: {
						suggest: {
							typeIncludes: `racePurposeDetails`
						},
						createOptions: {
							type: `racePurposeDetails`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
